const ENTER_KEY = 13
const LEFT_KEY = 37
const RIGHT_KEY = 39
const SPACE_KEY = 32
const TAB_KEY = 9

/**
 * Used for determining if a keyDown function should allow callback to be run
 * based on what key is being pressed.
 * This is to ensure proper onKeyX handlers are not triggered on any key X event
 * but on just the keys specified.
 *
 * @param {React.SyntheticEvent} e
 * @param {function} callback
 * @param {number|number[]} matchingKeys
 */
function keyPress(e, callback, matchingKeys = undefined) {
  let keys = [ENTER_KEY]
  if (matchingKeys) {
    keys = keys.concat(matchingKeys)
  }
  if (keys.includes(e.keyCode)) {
    callback(e)
  }
}

function shiftAndTabPress(e) {
  return e.shiftKey && e.keyCode === TAB_KEY
}

export default keyPress

export { LEFT_KEY, RIGHT_KEY, SPACE_KEY, ENTER_KEY, TAB_KEY, shiftAndTabPress }
